import React from 'react'
import classNames from "classnames"
import FJButtonLoadingIcon from '../../../icon/FJButtonLoadingIcon.svg'
import InlineSVG from "react-inlinesvg";
import './FJIconButton.less';

const SIZE_TYPE = {
  SMALL: "SMALL",
  MIDDLE: "MIDDLE",
  BIG: "BIG",
};

function FJIconButton(props) {
  let {
    icon,
    className,
    active,
    style,
    loading,
    disabled,
    tooltip,
    size = 'middle',
    forwardRef,
    onClick,
    onMouseDown,
  } = props;
  if (className) {
    className = className.split(/\s+/);
  }
  let sizeClassName;
  switch (size.toUpperCase()) {
    case SIZE_TYPE.SMALL:
      sizeClassName = 'c-icon-btn-small';
      break;
    case SIZE_TYPE.MIDDLE:
      sizeClassName = 'c-icon-btn-middle';
      break;
    case SIZE_TYPE.BIG:
      sizeClassName = 'c-icon-btn-big';
      break;
    default:
      sizeClassName = 'c-icon-btn-middle';
  }
  let btnClass = classNames('btn c-icon-btn', className, sizeClassName, {
    active: active,
    loading: loading,
    disabled: disabled
  });
  return (
    <button ref={forwardRef} style={style} onMouseDown={(e) => {
      if (!disabled && onMouseDown) {
        onMouseDown(e);
      }
    }} onClick={(e) => {
      if (!disabled) {
        if (onClick) {
          if (forwardRef && forwardRef.current) {
            forwardRef.current.blur();
          }
          e.target.blur();
          onClick(e);
        }
      }
    }} tooltip={tooltip} className={btnClass}>
      {
        loading ? <InlineSVG src={FJButtonLoadingIcon} element='div'/> : icon
      }
    </button>
  );
}

export default FJIconButton;
